"use client"
import React, { useRef, useState } from "react"
import styles from "@css/modules/Resorts.module.scss"
import { Media } from "@components/Media"
import ResortList from "@components/Resort/ResortList"
import { Search } from "@css/icons/Search"
import { Resort } from "@t/Resort"
import "@css/modules/ResortSections.module.scss"

export function PageContent({ resorts }: { resorts: Resort[] }) {
    const [query, updateQuery] = useState("")
    const container = useRef(null)
    const onFastSearch = (value) => {
        const el = document.getElementById("search") as HTMLInputElement
        if (el) {
            el.value = value
        }
        updateQuery(value)
    }
    return (
        <div id="resorts" className={styles.root} ref={container}>
            <Media
                query="(max-width: 768px)"
                render={(matches) => {
                    if (matches) {
                        return (
                            <div className={styles.mobileContent}>
                                <h1 className={styles.title}>Start exploring possibilities like never before</h1>
                                <p className={styles.description}>Pick the resort which suits you and your pocket the best with our curated and revamped listing of contracts.</p>
                                <ResortList search={query} resorts={resorts} onFastSearch={onFastSearch} mobile />
                            </div>
                        )
                    }
                    return (
                        <>
                            <div className={styles.left}>
                                <div className={styles.searchWrapper}>
                                    <input
                                        id="search"
                                        onChange={(event) => updateQuery(event.target.value)}
                                        className={styles.searchInp}
                                        placeholder="Search for your desired Resorts"
                                    />
                                    <label htmlFor="search" className={styles.searchIcon}>
                                        <Search />
                                    </label>
                                </div>
                                <ResortList search={query} resorts={resorts} onFastSearch={onFastSearch} />
                            </div>
                            <Media query="(min-width: 1128px)">
                                <div className={styles.right}>
                                    <img
                                        width={590}
                                        height={900}
                                        loading="eager"
                                        className={styles.bg}
                                        src="/images/reports_preview.jpg"
                                        srcSet="/images/reports_preview.jpg 1x, /images/resortd_preview@2x.jpg x2"
                                        alt="Resorts illustration"
                                    />
                                    <div className={styles.content}>
                                        <h1 className={styles.title}>Start exploring possibilities like never before</h1>
                                        <p className={styles.description}>
                                            Pick the resort which suits you and your pocket the best with our curated and revamped listing of contracts.
                                        </p>
                                    </div>
                                </div>
                            </Media>
                        </>
                    )
                }}
            />
        </div>
    )
}
